import React from 'react';
import { useTranslation } from 'react-i18next';
import { ZfBox, ZfIcon, ZfTypography } from '@zafire/react';

type PrivateBankingErrorProps = {
  message?: string;
};

export const PrivateBankingError: React.FC<PrivateBankingErrorProps> = ({ message }) => {
  const { t } = useTranslation();

  return (
    <ZfBox
      data-testid="private-banking-error"
      style={{
        width: '100%',
        height: '100vh',
        boxSizing: 'border-box',
        background: 'var(--bg-color-default-muted, #F8F9FB)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 'var(--gap-vertical-lg, 20px)',
        padding: 'var(--padding-vertical-xl, 24px)',
        textAlign: 'center',
      }}
    >
      <ZfIcon name="error" size="large" />
      <ZfTypography variant="title-large" role="heading">
        {t('pb.error.page.heading', 'This private banking overview is not available')}
      </ZfTypography>
      {message && <ZfTypography variant="body-large">{message}</ZfTypography>}
    </ZfBox>
  );
};
